import React, { Component } from 'react';
import { connect } from 'react-redux';
import Footer      from './../Footer';

class FooterContainer extends Component
{

    render = () =>
    {
        if (this.props.assets.fetched)
        {
            return <Footer
                theme={ this.props.assets.items.theme.footer }
                logos={ this.props.assets.items.footerLogos }
            />
        }
    }

}

const mapStateToProps = (state) => {
    return {
        assets: state.assets
    }
};

FooterContainer = connect(mapStateToProps)(FooterContainer);

export default FooterContainer;


// WEBPACK FOOTER //
// ./src/components/containers/FooterContainer.js